import { isEmpty } from 'lodash-es'

export const refresher = () => {
  const typedMessage = document.getElementById('textMessage')
  if (
    typedMessage === null ||
    isEmpty((typedMessage as HTMLInputElement)?.value)
  ) {
    console.info('Refreshing...')
    window.location.reload()

    return true
  }

  return false
}
